import { Company } from "app/modules/masters/companies/model/companies.model";

export interface CompaniesState {
  companies: Company[];
  loading: boolean;
  error: string | null;
  shortNameAvailable: boolean | null;
  shortNameChecking: boolean;
  companyNameChecking: boolean;
  companyNameAvailable: boolean | null;
  alterCodeAvailable: boolean | null;
  alterCodeChecking: boolean;
  // 🌐 For Global Search
  searchResultsByRow: {
    [rowIndex: number]: Company[];
  };

  // ✅ Separate manufacturer search result
  manufacturerResults: Company[];

  total: number;
}

export const initialCompaniesState: CompaniesState = {
  companies: [],
  loading: false,
  error: null,
  shortNameAvailable: null,
  shortNameChecking: false,
  companyNameChecking: false,
  companyNameAvailable: null,
  alterCodeAvailable: null,
  alterCodeChecking: false,
  searchResultsByRow: {},
  manufacturerResults: [],
  total: 0,
};
